import { ApiResponse, fetchApi } from './common';
import { DoctorSchedule, DoctorScheduleTemplate, ScheduleLocation } from './model';

// 创建医生排班模板请求接口
export interface CreateDoctorScheduleTemplateRequest {
  slot_name: string;
  weekday: number;
  start_time: string;
  end_time: string;
  capacity: number;
  schedule_location_id?: string | null;
}

// 批量创建医生排班模板请求接口
export interface BatchCreateDoctorScheduleTemplatesRequest extends Array<CreateDoctorScheduleTemplateRequest> {}

// 根据模板创建排班请求接口
export interface ProvisionSchedulesByTemplateRequest {
  start_date: string;
  end_date: string;
}

// 查询排班列表请求接口
export interface ListDoctorSchedulesRequest {
  start_time: string; // ISO8601 format
  end_time?: string; // ISO8601 format
}

// 批量删除医生排班请求接口
export interface DoctorScheduleBatchDeleteRequest {
  ids: string[];
}

// 创建医生排班请求接口
export interface CreateDoctorScheduleRequest {
  schedule_name: string;
  start_time: string; // ISO8601 format
  end_time: string; // ISO8601 format
  capacity_initial: number;
  schedule_location_id?: string | null;
}

// 创建或更新日程地点请求接口
export interface ScheduleLocationRequest {
  name: string;
  address: string;
}

// 排班API请求函数
export const scheduleApi = {
  // 创建医生排班模板
  createDoctorScheduleTemplate: async (data: CreateDoctorScheduleTemplateRequest): Promise<ApiResponse<DoctorScheduleTemplate>> => 
    fetchApi<DoctorScheduleTemplate>('/api/doctor_view/schedule_templates', 'POST', data),

  // 批量创建医生排班模板
  batchCreateDoctorScheduleTemplates: async (data: BatchCreateDoctorScheduleTemplatesRequest): Promise<ApiResponse<DoctorScheduleTemplate[]>> => 
    fetchApi<DoctorScheduleTemplate[]>('/api/doctor_view/schedule_templates/batch', 'POST', data),

  // 更新医生排班模板
  updateDoctorScheduleTemplate: async (templateId: string, data: CreateDoctorScheduleTemplateRequest): Promise<ApiResponse<DoctorScheduleTemplate>> => 
    fetchApi<DoctorScheduleTemplate>(`/api/doctor_view/schedule_templates/${templateId}`, 'PUT', data),

  // 获取医生排班模板
  getDoctorScheduleTemplate: async (templateId: string): Promise<ApiResponse<DoctorScheduleTemplate>> => 
    fetchApi<DoctorScheduleTemplate>(`/api/doctor_view/schedule_templates/${templateId}`, 'GET'),

  // 获取医生排班模板列表
  listDoctorScheduleTemplates: async (): Promise<ApiResponse<DoctorScheduleTemplate[]>> => 
    fetchApi<DoctorScheduleTemplate[]>('/api/doctor_view/schedule_templates', 'GET'),

  // 删除医生排班模板
  deleteDoctorScheduleTemplate: async (templateId: string): Promise<ApiResponse<null>> => 
    fetchApi<null>(`/api/doctor_view/schedule_templates/${templateId}`, 'DELETE'),

  // 根据模板创建指定日期范围内的排班
  provisionSchedulesByTemplate: async (data: ProvisionSchedulesByTemplateRequest): Promise<ApiResponse<null>> => 
    fetchApi<null>('/api/doctor_view/schedules/provision', 'POST', data),

  // 创建医生排班
  createDoctorSchedule: async (data: CreateDoctorScheduleRequest): Promise<ApiResponse<DoctorSchedule>> => 
    fetchApi<DoctorSchedule>('/api/doctor_view/schedules', 'POST', data),

  // 更新医生排班
  updateDoctorSchedule: async (scheduleId: string, data: CreateDoctorScheduleRequest): Promise<ApiResponse<DoctorSchedule>> => 
    fetchApi<DoctorSchedule>(`/api/doctor_view/schedules/${scheduleId}`, 'PUT', data),

  // 获取医生排班
  getDoctorSchedule: async (scheduleId: string): Promise<ApiResponse<DoctorSchedule>> => 
    fetchApi<DoctorSchedule>(`/api/doctor_view/schedules/${scheduleId}`, 'GET'),

  // 获取医生排班列表
  listDoctorSchedules: async (params: ListDoctorSchedulesRequest): Promise<ApiResponse<DoctorSchedule[]>> => {
    const queryString = new URLSearchParams(params as any).toString();
    return fetchApi<DoctorSchedule[]>(`/api/doctor_view/schedules?${queryString}`, 'GET');
  },

  // 删除医生排班
  deleteDoctorSchedule: async (scheduleId: string): Promise<ApiResponse<null>> => 
    fetchApi<null>(`/api/doctor_view/schedules/${scheduleId}`, 'DELETE'),

  // 批量删除医生排班
  batchDeleteDoctorSchedules: async (data: DoctorScheduleBatchDeleteRequest): Promise<ApiResponse<null>> => 
    fetchApi<null>('/api/doctor_view/schedules', 'DELETE', data),

  // 获取日程地点列表
  listScheduleLocations: async (): Promise<ApiResponse<ScheduleLocation[]>> => 
    fetchApi<ScheduleLocation[]>('/api/doctor_view/schedule_locations', 'GET'),

  // 创建日程地点
  createScheduleLocation: async (data: ScheduleLocationRequest): Promise<ApiResponse<ScheduleLocation>> => 
    fetchApi<ScheduleLocation>('/api/doctor_view/schedule_locations', 'POST', data),

  // 更新日程地点
  updateScheduleLocation: async (locationId: string, data: ScheduleLocationRequest): Promise<ApiResponse<ScheduleLocation>> => 
    fetchApi<ScheduleLocation>(`/api/doctor_view/schedule_locations/${locationId}`, 'PUT', data),

  // 删除日程地点
  deleteScheduleLocation: async (locationId: string): Promise<ApiResponse<null>> => 
    fetchApi<null>(`/api/doctor_view/schedule_locations/${locationId}`, 'DELETE'),
};